import { getLastDigit } from '../tools';

export default Engine =>
    class Digits extends Engine {
        getLastDigit = async () => {
            const pipSize = this.getPipSize();
            const lastTick = await this.getLastTick(false, true);
            return getLastDigit(lastTick, pipSize);
        };
        getLastDigitList = async () => {
            const pipSize = this.getPipSize();
            const ticks = await this.getTicks(true);
            return ticks.map(tick => getLastDigit(tick, pipSize));
        };
        getEvenOddAmount = async args => {
            const pipSize = this.getPipSize();
            const digits = await this.getTicks(true).then(ticks => ticks.slice(-args.amount).map(tick => getLastDigit(tick, pipSize)));
            return digits.reduce((a, b) => a + ((b % 2 === 0 && args.type === 'Even') || (b % 2 !== 0 && args.type === 'Odd') ? 1 : 0), 0);
        };
        getUnderOverAmount = async args => {
            const pipSize = this.getPipSize();
            const digits = await this.getTicks(true).then(ticks => ticks.slice(-args.amount).map(tick => getLastDigit(tick, pipSize)));
            return digits.reduce((a, b) => a + ((args.type === 'Under' && b < args.digit) || (args.type === 'Over' && b > args.digit)), 0);
        };
        getDigitsPercentage = async args => {
            const pipSize = this.getPipSize();
            const ticks = await this.getTicks(true);
            const digits = ticks.slice(-args.amount).map(tick => getLastDigit(tick, pipSize));
            const map = digits.reduce((cnt, cur) => ((cnt[cur] = cnt[cur] + 1 || 1), cnt), Object.assign({}, ...Array.from(Array(10), (_, i) => ({ [i]: 0 }))));
            return Number(((map[args.digit] * 100) / args.amount).toFixed(2));
        };
        getMostFrequentDigit = async ({ amount }) => {
            const pipSize = this.getPipSize();
            const ticks = await this.getTicks(true);
            const digits = ticks.slice(-amount).map(tick => getLastDigit(tick, pipSize));
            const map = digits.reduce((cnt, cur) => ((cnt[cur] = cnt[cur] + 1 || 1), cnt), Object.assign({}, ...Array.from(Array(10), (_, i) => ({ [i]: 0 }))));
            const tmp = Object.values(map);
            return tmp.indexOf(Math.max(...tmp));
        };
        getLeastFrequentDigit = async ({ amount }) => {
            const pipSize = this.getPipSize();
            const ticks = await this.getTicks(true);
            const digits = ticks.slice(-amount).map(tick => getLastDigit(tick, pipSize));
            const map = digits.reduce((cnt, cur) => ((cnt[cur] = cnt[cur] + 1 || 1), cnt), Object.assign({}, ...Array.from(Array(10), (_, i) => ({ [i]: 0 }))));
            const tmp = Object.values(map);
            return tmp.indexOf(Math.min(...tmp));
        };
        areTheLastDigitsTheSame = async ({ amount, digit }) => {
            const pipSize = this.getPipSize();
            const ticks = await this.getTicks(true);
            const digits = ticks.slice(-amount).map(tick => getLastDigit(tick, pipSize));
            const isValid = new Set(digits).size === 1 && (digit === 'same' ? true : digits[0] === Number(digit));
            return isValid;
        };
        getDecimals = async () => {
            const lastTick = await this.getLastTick(false, true);
            const asString = String(lastTick);
            const frac = asString.includes('.') ? asString.split('.')[1] : '';
            return frac;
        };
    };
